import { Component, AfterViewInit,ViewChild, OnInit, ɵConsole } from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform,IonItemSliding } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext,ResponseMessage } from '../../../../model/common';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from "../../../../bizlogic/servicesbll";
import { GridBaseCase } from '../../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
import { Data } from 'src/model';
declare var app;
@Component({
  selector: 'app-mz-add-schedule',
  templateUrl: './mz-add-schedule.component.html',
  styleUrls: ['./mz-add-schedule.component.scss']
})
export class MzAddScheduleComponent extends GridBaseCase implements AfterViewInit, OnInit {
  ch: any;//日历汉化配置
  data:Data;
  minDate:Date;
  fm:any={};
  Today = {
    day: null,
    month: null,
    year: null
  };
  startTime:any;
  endTime:any;
  OperationType:any;
  isCheckOldDate = false;//是否选中过去的日子
  checkDate: any = new Date();//选中的日期
  selectArray:Array<string> =[];//选择的日期
  checkDatePlan = false;//选中的日期是否存在计划
  deleteSchedule:boolean = false;//删除排班
  storeArray:Array<string> = [];//门店列表
  storeArrayType:Array<any> = [];//门店类型
  
  /**
   * 所有日程
   */
  scheduleDate = [];
  scheduleDateString = "";

  searchDate: any = null;//每次获取列表查询日期
  initGetData:boolean = true;
  /** 
   * 当前选中日程
  */
  currentSchedule = [];
  @ViewChild(IonItemSliding) itemSliding: IonItemSliding;
  tabsIndex = 0;//选中tabs
  schedulingSummaryObj:any = {};//排班统计信息
  isAndroid4:boolean = false;//是否是安卓4以下
  isAndroid5Down:boolean = false;//是否是安卓5以下
  isAndroid5:boolean = false;//是否是安卓5
  typeselect:any; // 名称
  remarkShow:boolean = false; // 是否显示备注输入框
  selectValue:any; //  排版类型
  stordValue:any; //  门店类型
  nowData:Date = new Date();
  constructor(
   
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private router: Router,
    public com: CommonService
  ) {
    super();
    const d = new Date();
    this.Today.year = d.getFullYear();
    this.Today.month = d.getMonth();
    this.Today.day = d.getDate();
    this.fm.SNStartDate="";
    this.fm.SNEndDate="";
    this.fm.Remark="";// 填写备注字段
    let _nowDate:Date = new Date();
     let _setDate=_nowDate.setDate(_nowDate.getDate()+1);
     this.nowData = new Date(_setDate);
    this.ch = {
      /** 每周第一天，0代表周日 */
      firstDayOfWeek: 0,
      /** 每周天数正常样式 */
      dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      /** 每周天数短样式（位置较小时显示） */
      dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      /** 每周天数最小样式 */
      dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
      /** 每月月份正常样式 */
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      /**每月月份短样式 */
      monthNamesShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      today: '今天',
      clear: '清除'
    };
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let prevMonth = (month === 0) ? 11 : month -1;
        let prevYear = (prevMonth === 11) ? year - 1 : year;
        let nextMonth = (month === 11) ? 0 : month + 1;
        let nextYear = (nextMonth === 0) ? year + 1 : year;
        this.minDate = new Date();
        this.minDate.setMonth(month);
        this.minDate.setFullYear(year);
   
  }

  ngAfterViewInit() {
    
    const that = this;
    that.bondStoreInfop();
    that.bondStoreInfoType();
    let date = {
      year: that.Today.year,
      month: that.Today.month + 1
    }
    that.timeOutSearchDate(date);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let id = that.activaRouter.snapshot.paramMap.get('id');
   let parms = that.activaRouter.snapshot.paramMap.get("type");
   console.log(that.fm.Remark,"填写备注的值");
  
  
  }
  ngOnInit() {
    // const that = this;
    // that.getScheduleList();
    
  }

  /**
   * 
   * @param num 选中
   */
  tabsEvent(num){
    const that =this;
    this.tabsIndex = num;
  }


  /**
   * 获取日程列表
   */
  getScheduleList(loads) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const type = that.activaRouter.snapshot.paramMap.get('type');
    let id = that.activaRouter.snapshot.paramMap.get('id');
    if(id){
      id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    }
    let body = new WebParameterContext();

    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = PageName;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let _id = that.com.GetAccount.Id;
    if(type == "view"){
      _id = id;
    }
    body.RequestBody = JSON.stringify({ "a_SNStartDate": that.searchDate, "a_FK_SystemUser_ID": _id });
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      loads.dismiss();
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }

      
      that.http.post(app.DEFAULTURL, body).then(data => {
        loads.dismiss();
        data = HandleServerContextAfterDBRequest(body, data);
        that.scheduleDate = [];
        if (data.ResponseMessage.Success) {
          // that.scheduleDate = data.Status.Datas;
          if(data.Status.Datas){
            data.Status.Datas.forEach(function (item) {
              let objfield = {};
              // debugger;
              that.element.selectItemList.selectItem.forEach((element, index) => {
                if (element.bindingField) {
                  objfield[element.bindingField] = item[element.field]||"";
                }
              });
              // //debugger;
              that.scheduleDate.push(objfield);
            });
          }
          if(that.initGetData || that.deleteSchedule){
            that.initGetData = false;
            that.deleteSchedule = false;
            that.DateSelect(that.checkDate);
          }
          // that.schedulingSummary();//统计信息；
        }
      }).catch(error => {
        console.log(error);
        loads.dismiss();
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
        // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
        //   //that.router.navigate(["/login"]);
        // })
      })

    
  }

  //删除临时计划
  deleteData(item) {
    const that = this;
    that.msg.Confirm('确认删除？').then(data => {
      if (data) {
        that.itemSliding.closeOpened();
        const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
        let body = new WebParameterContext();

        if (that.element.selectItemList.gridViewConfigName) {
          body.ConfigName = that.element.selectItemList.gridViewConfigName;
        } else if (that.ConfigName) {
          body.ConfigName = that.ConfigName;
        }
        body.OpType = "delete";
        body.ConfigType = "form";
        body.Client.PageName = PageName;
        body.Client.ApiType = "Element";
        body.Client.Name = PageName;
        body.Client.ClientType = 2;
        if (that.platform.is("android")) {
          body.Client.ClientType = 0;
        } else if (that.platform.is("ios")) {
          body.Client.ClientType = 1;
        }

        body.RequestBody = JSON.stringify({ "a_ID": item.ID });
        body = HandleWebParameterContextBeforeDBRequest(body);
        if (!body.ResponseMessage.Success) {
          that.msg.Alert(body.ResponseMessage.ErrorMessage);
          return;
        }
        that.msg.Loading("数据加载中...").then(loads=>{
          that.http.post(app.DEFAULTURL, body).then(data => {
            data = HandleServerContextAfterDBRequest(body, data);
            loads.dismiss;
            if (data.ResponseMessage.Success) {
              setTimeout(()=>{
                that.getScheduleList(loads);
              },100);
              that.deleteSchedule = true;
            }
          }).catch(error => {
            console.log(error);
            loads.dismiss;
            that.msg.Alert(error.ResponseMessage.ErrorMessage);
            // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
            //   //that.router.navigate(["/login"]);
            // })
          })
          loads.present();
        })
        
      }
    })

  }
  /**
* 下拉刷新数据
* @param event
*/
  //  doRefresh(event) {
  //   this.getScheduleList();
  //   event.target.complete();
  // }



  /**
   * 获取当天日程
   */
  getCurrentSchedule(day) {
    let that = this;
    that.currentSchedule = [];
    let d = this.DateFormat(day);
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(d) > -1) {
        if(item.beginDate){
          item.beginDate = item.beginDate.replace(/-/g, "/");
        }
        if(item.SNEndDate){
          item.SNEndDate = item.SNEndDate.replace(/-/g, "/");
        }
        that.currentSchedule.push(item);
      }
    })
  }


  /**
   * 选中日期
   * @param ev 
   * @param d 
   */
  oldCheckDate = [];

  DateSelect(d) {
    let that = this;
    // //debugger;
    // let g=that.isDate(d);
    console.log(that.data,"that.data");
    // that.data = [""];
    // let _arrDate:Array<Date> =new Array<Date>();
    // if(d && d.length > 0){
    //   d.forEach(item=>{
    //     if(new Date(item).getTime() > new Date().getTime()){
    //       _arrDate.push(item);
    //     }
    //   });
    // }
    
    // if(that.data&&  that.data.length > 0){
    //   let _dArr = that.data;
    //   _dArr.forEach((item,i)=>{
    //     that.data.splice(i,1);
    //   })
    // }
    // that.data = _arrDate;
    let _currentCheckDate = null;//本次选中的日期；
    // if(that.oldCheckDate.length == 0){
    //   that.oldCheckDate = d;
    //   if(d.length > 0){
    //     _currentCheckDate = d[0];
    //   }
    // }else{
      
      
    //   let _t = null;
    //   if(that.oldCheckDate.length > d.length){
    //     that.oldCheckDate.forEach(item=>{
    //       d.forEach(item2=>{
    //         let _t2 = false;
    //         if(item ==item2){
    //           _t2 = true;
    //         }
    //         if(_t2){

    //         }
    //       })
    //     })
    //   }else{

    //   }

    // }
    if(Array.isArray(d)){
      if(!that.isDatepaiban(d)){
         that.msg.Alert("添加排班不能选择之前或已排班的日期");
         return;
      }
      if(!that.isDateMoneth(d)){
        that.msg.Alert("添加排班只支持添加当月（当天之后）和下月的排班");
        return;
      }
    }
    that.selectArray =d;//
    that.checkDate=d;
    //  that.arrayDate(d);
    that.getCurrentSchedule(that.checkDate);
    const d1 = new Date(d.toString().replace(/-/g, "/"));
    let checkDay = {};
    checkDay['year'] = d1.getFullYear();
    checkDay['month'] = d1.getMonth();
    checkDay['day'] = d1.getDate();
    that.isCheckOldDate = that.isOldDate(checkDay);
    
    that.checkDatePlan = that.getSchedule(checkDay);//当前选中日期是否存在
    let monthDom = document.getElementsByClassName("ui-datepicker-month");
    let cMonth = checkDay['month'];
    if(monthDom.length > 0){
      cMonth = monthDom[monthDom.length-1]['innerText'].replace('月', '');
    }
    if ((d1.getMonth() + 1) != parseInt(cMonth)) {
      that.currentSchedule = [];//清除选中天的排班计划
      let date = {
        year: d1.getFullYear(),
        month: d1.getMonth() + 1
      }
    
    }

  }
  EventBind(item){
    const that=this;
    console.log(item);
    // //debugger;
   let id = this.activaRouter.snapshot.paramMap.get('id');
   let type = this.activaRouter.snapshot.paramMap.get('type');
   if(id){
     id = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
     if(type!="add"){
       if(id.indexOf("-")==-1){
        id= this.com.GetAccount.Id;
       }
      localStorage.setItem("fscheduleId",id);//缓存当前登录人
     }
   }
   const d1 = new Date(this.checkDate.toString().replace(/-/g, "/"));//获取当前选中的日期日期
     let d=new Date();
   const d2 = new Date(d.toString().replace(/-/g, "/"));
   if(d1.getTime()>d2.getTime()){//当前选择的日期大于当前日期才可以编辑
    // console.log(d1);
    if(this.checkDate){
      localStorage.setItem('scheduleDate', this.DateFormat(this.checkDate));
      // if(item.state!=1){
      //   this.com.setHistoryUrl();
      //   this.router.navigate(["/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime]);
      // }else{
      //   this.msg.Alert("已审批通过，不可修改");
      // }
      this.com.setHistoryUrl();
      // this.router.navigate(["/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime]);
      this.com.Go("/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime);
    }else{
      this.msg.Alert('请选择日期');
    }
  }else{
    that.msg.Alert("当天或之前的排班不可操作");
  }
  // else{
  //   this.msg.Alert('历史数据不可操作');
  // }
  //  this.router.navigate(["/tabs/contact/ScheduleMakingForm/edite/"+item.ID+"&"+this.com.getNowDatetime]);
  }

  /**
   * 判断日期是否存在
   * @param day 
   */
  getSchedule(date) {
    let date1 = '';
    if (!date.year) { return false; } else {
      date1 = date.year + '-' + ((date.month + 1) < 10 ? '0' + (date.month + 1) : (date.month + 1)) + '-' + (date.day < 10 ? '0' + date.day : date.day);
    }
    let isSchedule = false;
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date1) > -1) {
        isSchedule = true;
      }
    })
    return isSchedule;
  }

  /**
   * 是否是过去的日期
   * @param date 
   */
  isOldDate(date) {

    if (date) {
      if (date.year < this.Today.year) {
        return true;
      } else if (date.year == this.Today.year) {
        if (date.month < this.Today.month) {
          return true;
        } else if (date.month == this.Today.month) {
          if (date.day < this.Today.day) {
            return true;
          }
        }
      }
    }
  }
  /**
   * 
   * @param d 获取当前日期
   */
  arrayDate(d:any):Array<string>{
    let tp:Array<string> =new Array<string>();
  console.log("d");
    // if(d== d){
    //   this.msg.Alert("请选择排版日期哦!");
    //   return;
    // }
    if(!Array.isArray(d)){
        return tp;
    }
      d.forEach(item=>{
        const d1 = new Date(item.toString().replace(/-/g, "/"));
        let month:any=d1.getMonth()+1;
        if(d1.getMonth()+1<10){
          month="0"+month;
        }
        let date:any = d1.getDate();
        if(d1.getDate()<10){
          date="0"+date;
        }
          let checkDay =d1.getFullYear()+"-"+month+"-"+date;
          tp.push(checkDay);
          });
          return tp; 
  
   
  }
  /**
   * 判断选择 得日期”年月日“是否小于当天
   * @param d 
   */
  isDate(d:Array<string>):boolean{
    let isfalse:boolean=true;
    let msg:any=new ResponseMessage();
    let day:Date = new Date();
    let daymonth:any = day.getMonth()+1;
    if(day.getMonth()+1<10){
      daymonth="0"+daymonth;
    }
    let daysday:any=day.getDate();
    if(day.getDate()<10){
      daysday="0"+day.getDate();
    }
    let _day = day.getFullYear()+""+daymonth+""+daysday;
    let _d=parseInt(_day);
    d.forEach(item=>{
      const d1 = new Date(item.toString().replace(/-/g, "/"));
      let month:any=d1.getMonth()+1;
      if(d1.getMonth()+1<10){
        month="0"+month;
      }
      let date:any = d1.getDate();
      if(d1.getDate()<10){
        date="0"+date;
      }
        let checkDay =d1.getFullYear()+""+month+""+date;
       console.log(this.scheduleDate,"op");
        let _c=parseInt(checkDay);
        if(_c<=_d){
          isfalse=false;
        }
    });
    return isfalse;
  }
  /**
   * 选择的日期只支持排当月之后到下月排班
   * @param d 
   */
  isDateMoneth(d:Array<string>):boolean{
    let isfalse:boolean=true;
    let day:Date = new Date();
    let dayyear:any = day.getFullYear();//当前年
    let daymonth:any = day.getMonth()+1;//当前月
    if(daymonth<10){
      daymonth=0+""+daymonth;
    }
    let daylast:Date = new Date();//当前年加一个月、
             daylast.setMonth(daylast.getMonth()+1);//当前月加1；
      let yearLast:any=daylast.getFullYear();
      let monthLast:any = daylast.getMonth()+1;
      if(monthLast<10){
        monthLast=0+""+monthLast;
      }
    d.forEach(item=>{
      const d1 = new Date(item.toString().replace(/-/g, "/"));
      let month:any=d1.getMonth()+1;
      if(month<10){
        month=0+""+month;
      }
      let year:any = d1.getFullYear();
      if(dayyear==year){
        if(month-daymonth>1){//选择的月份大于当前月则不通过，前提年份一样。
          isfalse=false;
        }
      }else{
        //选择的年月不能小于当月并且不能大于下个月
        let selectDate:number = parseInt(year+""+month);
        let nowDate:number = parseInt(dayyear+""+daymonth);
        let lastDate:number=parseInt(yearLast+""+monthLast);
        if(selectDate<nowDate && selectDate>lastDate){
          isfalse=false;
        }
        if(selectDate<nowDate){
          isfalse=false;
        }
        if(isfalse){
          if(selectDate>lastDate){
            isfalse=false;
          }
        }

      }
      
    });
    return isfalse;
  }
    /**
   * 判断选择的日期是否排班
   * @param d 
   */
  isDatepaiban(d:Array<string>):boolean{
    const that = this;
    let isfalse:boolean=true;
    let day:Date = new Date();
    let daymonth:any = day.getMonth()+1;
    if(day.getMonth()+1<10){
      daymonth="0"+daymonth;
    }
    let daysday:any=day.getDate();
    if(day.getDate()<10){
      daysday="0"+day.getDate();
    }
    let _day = day.getFullYear()+""+daymonth+""+daysday;
    let _d=parseInt(_day);
    d.forEach(item=>{
      const d1 = new Date(item.toString().replace(/-/g, "/"));
      let month:any=d1.getMonth()+1;
      if(d1.getMonth()+1<10){
        month="0"+month;
      }
      let date:any = d1.getDate();
      if(d1.getDate()<10){
        date="0"+date;
      }
      //debugger;
        let checkDay =d1.getFullYear()+"-"+month+"-"+date;
        that.scheduleDate.forEach(item=>{
          if(item.date.indexOf(checkDay)>=0){
            isfalse=false;
          }
        });
    });
    return isfalse;
  }
  /**
   * 查看日程详情
   * @param item 选中的日程
   */
  // scheduleDetail(item) {
  //   this.router.navigateByUrl("/tabs/contact/CalendarForm/view/" + item['id']);
  // }
bondStoreInfop(){
  const that=this;
  // UserJurisdictionStoreRelation
  let body = new WebParameterContext();
  body.ConfigName="UserJurisdictionStoreRelation";
  body.OpType = "query";
  body.ConfigType = "view";
  body.Client.PageName = "UserJurisdictionStoreRelation";
  body.Client.ApiType = "Element";
  body.Client.Name = "UserJurisdictionStoreRelation";
  body.Client.ClientType = 2;

  body.RequestBody = JSON.stringify({ "a_FK_SystemUser_ID": that.com.GetAccount.Id });
  that.msg.Loading("数据加载中...").then(loads=>{
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      // //debugger;
      if (data.ResponseMessage.Success) {
        that.storeArray=data.Status.Datas;
        that.fm.FK_Store_ID=data.Status.Datas[0]["a_FK_Store_ID"];
        that.fm.stordValue=data.Status.Datas[0]["b_Name"];
      }
    }).catch(error => {
      console.log(error);
      loads.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
      //   //that.router.navigate(["/login"]);
      // })
    })
    loads.present();
  });
  
}
/**
 * 门店类型
 */
bondStoreInfoType(){
  const that=this;
  // UserJurisdictionStoreRelation
  let body = new WebParameterContext();
  body.ConfigName="TBScheduleTypeXML";
  body.OpType = "query";
  body.ConfigType = "view";
  body.Client.PageName = "TBScheduleTypeXML";
  body.Client.ApiType = "Element";
  body.Client.Name = "TBScheduleTypeXML";
  body.Client.ClientType = 2;
  body.RequestBody= JSON.stringify({"a_Code":{"Value":"T008","CompareOperator":"<>","Type":"CompareValue"}});
  that.msg.Loading("数据加载中...").then(loads=>{
    that.http.post(app.DEFAULTURL, body).then(data => {
      loads.dismiss();
      if (data.ResponseMessage.Success) {
        that.storeArrayType=data.Status.Datas;
        that.fm.FK_TBScheduleType_ID=data.Status.Datas[0]["a_ID"];
        that.fm.selectValue=data.Status.Datas[0]["a_TypeName"];
      }
    }).catch(error => {
      loads.dismiss();
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
      //   //that.router.navigate(["/login"]);
      // })
    });
    loads.present();
  });
  
}

addPlan() {
    if(this.checkDate){
      this.com.setHistoryUrl();
      localStorage.setItem('scheduleDate', this.DateFormat(this.checkDate));
      const type = this.activaRouter.snapshot.paramMap.get('type');
      if(type == "view"){
        const id = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
        localStorage.setItem('scheduleId', id);
      }else{
        localStorage.removeItem('scheduleId');
      }
      // this.router.navigateByUrl("/tabs/contact/ScheduleMakingForm/add/"+this.com.getNowDatetime);
      this.com.Go("/tabs/contact/ScheduleMakingForm/add/"+this.com.getNowDatetime);
      
    }else{
      this.msg.Alert('请选择日期');
    }
  }

  /**
   * 格式化日期
   * @param date 日期
   */
  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g, "/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }


  /**
   * 月份改变
   * @param event 
   */
  monthChange($event) {

    const that = this;
    // debugger;
    that.checkDate = null;
    that.currentSchedule = [];////清除选中天的排班计划
    // setTimeout(() => {
    //   that.getSearchDate($event);
    // },200);
    that.timeOutSearchDate($event);
  }

  /**
   * 设置月份查询条件
   * @param date 
   */
  getSearchDate(date,loads) {
    const that = this;
    const d = date;
    let timerI = 0;
    let timer = setInterval(()=>{
      let domList:any = document.getElementsByClassName("ui-datepicker-calendar");
      timerI++;
      if(domList.length == 0){
        if(timerI < 10){
          return;
        }else{
          clearInterval(timer);
        }
      }else{
        clearInterval(timer);
      }
      
      let dom = null;
      const l = domList.length;
      if(l > 0){
        dom = domList[l-1];
      }else{}
      
      let timerI2 = 0;
      let timer2 = setInterval(()=>{
        const beginEle = dom.children[1].children[0].children[0]; 
        const endEle = dom.children[1].lastElementChild.lastElementChild;
        timerI2++;
        if(!beginEle && !endEle){
          if(timerI2 < 10){
            return;
          }else{
            clearInterval(timer2);
          }
        }else{
          clearInterval(timer2);
        }
        const beginDay = beginEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        const endDay = endEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        let beginMonth = beginEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month - 1) : (d.month);
        let endMonth = endEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month + 1) : (d.month);
        let beginYear = d.year;
        let endYear = d.year;
        if (beginMonth == 0) {
          beginMonth = 12;
          beginYear = d.year - 1;
        } else if (endMonth == 13) {
          endMonth = 1;
          endYear = d.year + 1;
        }
    
        const beginDate = beginYear + '-' + beginMonth + '-' + beginDay + ' 00:00:00';
        const SNEndDate = endYear + '-' + endMonth + '-' + endDay + ' 23:59:59';
        this.searchDate = that.com.BetweenDate(beginDate, SNEndDate);
        that.getScheduleList(loads);
      },400);
    },400);
  }

  timeOutSearchDate(date){
    const that = this;
    that.msg.Loading("数据加载中...").then(loads=>{
      setTimeout(() => {
        that.getSearchDate(date,loads);
      },200);
      loads.present();
    })
  }

  /**
   * 工作类型
   * @param date 
   */
  getWorkState(date){
    let that = this;
    let text='';
    let date1 = '';
    if (!date.year) 
    { return text;  }
     else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }

    this.scheduleDate.forEach(function (item, i) {
      // console.log(item,"所有得东西&&&&&");
      // console.log(item.date,"显示时间");

      if (item.date && item.date.indexOf(date1) > -1) {
          console.log(item,"666666666666666666666666666666666")
          if(item.schedulingMethod == 1 || item.schedulingMethod == "1" ){
            item.ShortName ="临";
          }
         text= that.getWorkStateText(item);
        }

      })
      return text;
  }

  getWorkStateText(item) {
    // let value=item.type;
    //已拒绝的不显示
    // console.log( item);
    console.log(item);
      let value = item.ShortName;
      console.log(value);
    //已拒绝的不显示
//    return value;
    if(item&&item.state!=2){
       return value;
    }
  //   if(item&&item.state!=2){
  //   switch (value)
  //   {
  //       case "T001":
  //           return "早";
  //       case "T002":
  //           return "中";
  //       case "T003":
  //         return "晚";
  //       case "T004":
  //           return "全";
  //       case "T005":
  //         return "年";
  //       case "T006":
  //         return "病";
  //       case "T007":
  //         return "休";
  //       case "T008":
  //         return "临";
  //         case "T009":
  //           return "其";
  //   }
  // }
}


  /**
   * 排班统计
   * @param  
   */
  schedulingSummary(){
    let monthDom = document.getElementsByClassName("ui-datepicker-month");
    let yearDom = document.getElementsByClassName("ui-datepicker-year");
    let m = null;
    let y = null;
    if(yearDom.length > 0){
      y = yearDom[yearDom.length-1]['innerText'].replace('年', '');
    }
    if(monthDom.length > 0){
      m = monthDom[monthDom.length-1]['innerText'].replace('月', '');
      m = m < 10 ? "0"+m : m;
    }
    const date = y + "-" + m;
    let currentMonthData = [];
    let workType1 = [];
    let workType2 = [];
    let workType3 = [];
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date) > -1) {
        currentMonthData.push(item);
        if(item.type == "T001"){
          workType1.push(item);
        }else if(item.type == "T002"){
          workType2.push(item);
        }else if(item.type == "T003" || item.type == "T004"){
          workType3.push(item);
        }
      }
    })

    const _currentMonthDays = new Date(y,m,0).getDate();
    this.schedulingSummaryObj = {
      monthDays:_currentMonthDays,
      total:currentMonthData.length,
      workType1:workType1.length,
      workType2:workType2.length,
      workType3:workType3.length,
      noWorkDays:_currentMonthDays - currentMonthData.length
    }

  }
  // 开始时间结束时间比较大小
   CompareDate(t1,t2){
    let date = new Date();
    var a = t1.split(":");
    var b = t2.split(":");
    return date.setHours(a[0],a[1]) > date.setHours(b[0],b[1]);
}

 checkdate(start, end) {
    const that = this;
    let date = new Date();
    let a = start.split(":");
    let b = end.split(":");
      if (date.setHours(a[0], a[1]) > date.setHours(b[0], b[1])) {
        that.msg.Alert("请选择大于当天的日期");
      return ;
      }
  }




// 选中的排版类型
typechange(type){
  const that =this;
  // debugger;
  that.storeArrayType.forEach(item => {
    if ( item["a_ID"] == type) {
      that.selectValue =item["a_TypeName"];
    }
  })
  that.storeArrayType.forEach(function (item, i) {
      console.log(item["a_Code"],"显示的东西");
      if(type == item["a_ID"]){
        that.selectValue = item["a_TypeName"];
      }
      
    });
    if(that.selectValue== "年假" || that.selectValue== "病假" || that.selectValue== "调休" || that.selectValue== "其他"){
      that.fm.SNStartDate="00:00";
      that.fm.SNEndDate="00:00";
      that.remarkShow = true;
    }else{
      if(that.selectValue=="早班"){
        that.fm.SNStartDate="06:00";
        that.fm.SNEndDate="10:00";
      }else if(that.selectValue=="中班"){
        that.fm.SNStartDate="10:00";
        that.fm.SNEndDate="14:00";
      } else if(that.selectValue=="晚班"){
            that.fm.SNStartDate="14:00";
            that.fm.SNEndDate="20:00";
        }
      else if(that.selectValue=="全天"){
        that.fm.SNStartDate="06:00";
        that.fm.SNEndDate="20:00";
          }else{
            that.fm.SNStartDate="00:00";
            that.fm.SNEndDate="00:00";
          }
          // else{
          //   that.fm.SNStartDate="";
          //   that.fm.SNEndDate="";
          // }
      
      that.remarkShow = false;
    }
  
}
// 门店匹配
stordchange(id){
  const that =this;
  that.storeArray.forEach(item => {
    if (item["a_FK_Store_ID"] == id) {
      that.stordValue =item["b_Name"];
    }
  })
}
EventInputChange($event){
  this.fm.Remark = $event.detail.value;
}

//备注输入
RemarkInput(e){
  let that=this;
 if(e&&e.target.value){
   if(e.target.value.length>300){
     e.target.value=e.target.value.substr(0,300);
     that.fm.Remark=e.target.value;
    }
  }
}

    /**
   * 提交
   */
  EventSubmit(ev){
    const that=this;
    //debugger;
    // return;
    let array=[];
    if(!that.data){
      that.msg.Alert("请选择需要排班得日期");
      return;
    }
    array=that.arrayDate(that.data);
    console.log(array,"内容日期");
    if(array.length<=0){
      that.msg.Alert("请选择需要排班得日期");
      return;
    }
    if(Array.isArray(that.data)){
      if(!that.isDate(that.data)){
        that.msg.Alert("添加排班不能小于当天的日期");
        return;
      }
      
      if(!that.isDatepaiban(that.data)){
        that.msg.Alert("添加排班不能选择之前或已排班的日期");
        return;
     }
     if(!that.isDateMoneth(that.data)){
      that.msg.Alert("添加排班只支持添加当月（当天之后）和下月的排班");
      return;
    }
    }
    if(typeof(that.fm.FK_TBScheduleType_ID) == "undefined"){
      that.msg.Alert("请选择排版类型哦!");
      return;
    }
    if(!that.fm.SNStartDate){
      that.msg.Alert("开始时间不能为空哦!");
      return;
    }
    if(!that.fm.SNEndDate){
      that.msg.Alert("结束时间不能为空哦!");
      return;
    }
    if( !that.fm.FK_Store_ID){
      that.msg.Alert("门店不能为空哦!");
      return;
    }
 
    let oiwork:boolean=true;
    if(that.selectValue== "年假" || that.selectValue== "病假" || that.selectValue== "调休" || that.selectValue== "其他"){
     
      if(!that.fm.Remark){
        that.msg.Alert("申请理由不能为空哦!");
        return;
      }
    }else{
      that.fm.Remark="";
    }
    // if(that.selectValue== "本休" || that.selectValue== "年假" || that.selectValue== "病假" || that.selectValue== "调休" || that.selectValue== "其他"){
    //   oiwork=false;
    // }
    let num1:number= parseInt(that.fm.SNStartDate.replace(":","")||0);
    let num2:number=parseInt(that.fm.SNEndDate.replace(":","")||0);
    // if(oiwork){
      if(num2<=num1){
        that.msg.Alert("结束时间不能小于等于开始时间哦!");
        return;
      }
    // }
   
     // 获取得选择得日期数组
    let _arrayList:Array<any>=new Array<any>();
    // let _dy:Array<any>=new Array<any>();
      array.forEach((item)=>{
        let _dy:any={
          "FK_TBScheduleType_ID":that.fm.FK_TBScheduleType_ID,
          "SNStartDate":item+'\xa0'+that.fm.SNStartDate + ":00", //开始时间
          "SNEndDate":item+'\xa0'+that.fm.SNEndDate + ":00", //开始时间
          "FK_Store_ID":that.fm.FK_Store_ID //开始时间
        };
         let mark_key:any=that.scheduleDate.find(ut=>ut.date.split(" ")[0]==item);
        if(mark_key){
          _dy["ID"]=mark_key.ID;
        }
        _dy["Remark"] = that.fm.Remark || "";
        _arrayList.push(_dy);
      });
     
     console.log(_arrayList,"提交的日期提交的日期");
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
            const type = that.activaRouter.snapshot.paramMap.get('type');
            let id = that.activaRouter.snapshot.paramMap.get('id');
            if(id){
              id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
            }
            let body = new WebParameterContext();
            body.ConfigName = "BatchScheduleNormal";
            body.OpType = "ADD";
            body.ConfigType = "form";
            body.Client.PageName = PageName;
            body.Client.ApiType = "Content";
            body.Client.Name = that.template.content.name;
            body.Client.ClientType = 2;
            body.RequestBody=JSON.stringify(_arrayList);
      console.log(JSON.stringify(_arrayList),"转json全部数据");
      // return;
      that.msg.Confirm("确认批量添加排班吗?","取消","确定").then(fail=>{
          if(fail){   
            that.msg.Loading("请求中，请稍后...").then(load=>{
              that.http.post(app.DEFAULTURL, body).then(data => {
                load.dismiss();
                if (data.ResponseMessage.Success) {
                  console.log(data,"成功之后数据");
                 that.com.goBack();
                }else{
                  that.msg.Alert(data.ResponseMessage.ErrorMessage)
                }
              }).catch(error => {
                load.dismiss();
                console.log(error);
                that.msg.Alert(error.ResponseMessage.ErrorMessage);
              });
              load.present();
            })
          }
      });
  }

}
